let isSessionExpireHandling = false;
let isSessionExpired = false;

/**
 * 페이지 로드/복원 시 세션 관련 플래그 초기화
 */
if (typeof window !== 'undefined') {
  // BFCache에서 복원될 때
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      console.warn('[Session] 🔄 BFCache 복원 - 세션 플래그 초기화');
      isSessionExpired = false;
      isSessionExpireHandling = false;
    }
  });
}

/**
 * fetch API를 사용하여 세션 유효성을 확인
 * redirect: 'manual'로 302 리다이렉트를 직접 감지
 *
 * @returns 세션이 유효하면 true, 명확한 세션 만료(401, 403, 302)이면 false
 *
 * 보수적 접근: 네트워크 오류나 서버 오류(5xx)는 세션 유효로 간주하여
 * 일시적인 장애로 인한 불필요한 로그아웃을 방지
 */
export const checkSessionByFetch = async (): Promise<boolean> => {
  if (typeof window === 'undefined') {
    return true;
  }

  if (isSessionExpired) {
    console.warn('[checkSessionByFetch] ⏸️ 이미 세션 만료 플래그 설정됨 - 스킵');
    return false;
  }

  console.warn('[checkSessionByFetch] 🔍 STEP 2: /backend/api/v1/users/me 세션 체크 시작');

  try {
    const url = `${window.location.origin}/backend/api/v1/users/me`;
    const response = await fetch(url, {
      method: 'GET',
      credentials: 'include',
      redirect: 'manual',
      headers: {
        accept: 'application/json',
      },
    });

    console.warn('[checkSessionByFetch] 📡 응답 수신:', {
      type: response.type,
      status: response.status,
      ok: response.ok,
    });

    if (response.type === 'opaqueredirect') {
      console.warn('[checkSessionByFetch] ❌ opaqueredirect 감지 → 세션 만료 확정');
      isSessionExpired = true;
      return false;
    }

    if (response.status === 401 || response.status === 403 || response.status === 302) {
      console.warn(`[checkSessionByFetch] ❌ ${response.status} 응답 → 세션 만료 확정`);
      isSessionExpired = true;
      return false;
    }

    if (response.ok) {
      console.warn('[checkSessionByFetch] ✅ 세션 유효');
      return true;
    }

    console.warn('[checkSessionByFetch] ⚠️ 예상치 못한 응답 (세션 유효로 간주):', response.status);
    return true;
  } catch (error) {
    console.error('[checkSessionByFetch] ⚠️ 네트워크 오류 (세션 유효로 간주):', error);
    return true;
  }
};

/**
 * 세션 만료 처리가 진행 중인지 확인
 */
export const isHandlingSessionExpire = (): boolean => isSessionExpireHandling;

/**
 * 세션이 만료되었는지 확인
 */
export const getIsSessionExpired = (): boolean => isSessionExpired;

/**
 * 세션 만료 처리 상태 설정
 */
export const setSessionExpireHandling = (value: boolean): void => {
  isSessionExpireHandling = value;
};
